import { PulseBaseProvider } from '../../base-classes';
import { getPollenSchema } from '../schemas/pollen';

const _pollenUri = '/data/lifestyle/pollen/v1/forecast';
const _pollenCacheKey = 'pollen';

export class PollenProvider extends PulseBaseProvider
{
    constructor(baseUrl, authId, secret, options, logger)
    {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_pollenCacheKey] = this.pollenSyncer.bind(this);
    }

    async pollenSyncer(params)
    {
        const {
            id
            , syncParams
            , resolve
            , reject
        } = params;

        const queryParams = {
            ...syncParams.stdParameters
            , latitude: syncParams.latitude
            , longitude: syncParams.longitude
            , verbose: syncParams.verbose
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _pollenUri
            , resolve
            , reject
            , null
            , syncParams.pulseApi
            , !syncParams.verbose ? getPollenSchema : null
        );
    }

    async getPollen(latitude, longitude, stdParameters, verbose, refresh = false)
    {
        const syncParams = {
            latitude
            , longitude
            , verbose: !!verbose
        };
        const id = JSON.stringify(syncParams);

        // Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh)
        {
            super.removeFromStorage(_pollenCacheKey, id);
        }
        return await super.loadFromStorage(_pollenCacheKey, id, syncParams);
    }
}

